'use client';

import { Locale } from '@core/Entities/Locale/Locale.entity';
import { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { saveCurrentCalculatorStateAtom } from '../../Atoms/PersistentCalculatorState.atom';
import { CalculatorMessages } from '../FinancingCalculator/Calculator.messages';
import { usePersistentCalculator } from '../FinancingCalculator/Hooks/UsePersistentCalculator';
import UniversalCalculator from '../FinancingCalculator/UniversalFinancingCalculator/UniversalCalculator';
import { FinanceHelpModalContent } from '../../Entities/FinanceHelpModal.entity';

type Props = {
  locale: Locale;
  vehicleId: string;
  vehicle: Vehicle;
  strings: CalculatorMessages;
  financeMessages: FinanceHelpModalContent;
};

/**
 * Client-side wrapper for the UniversalCalculator that ensures calculator state persistence
 * This automatically saves the calculator state to session storage whenever the component unmounts
 * or the user navigates away from the page.
 */
export const UniversalCalculatorClientWrapper = ({
  locale,
  vehicleId,
  vehicle,
  strings,
  financeMessages,
}: Props) => {
  usePersistentCalculator(vehicleId);

  const saveCalculatorState = useSetAtom(saveCurrentCalculatorStateAtom);

  useEffect(() => {
    saveCalculatorState();

    return () => {
      saveCalculatorState();
    };
  }, []);

  return (
    <UniversalCalculator
      locale={locale}
      strings={strings}
      vehicleId={vehicleId}
      vehicle={vehicle}
      financeMessages={financeMessages}
    />
  );
};
